<template>
  <div class="bind-phone-container">
    <!-- 标题栏 -->
    <van-nav-bar title="绑定手机" left-arrow @click-left="onClickLeft" class="custom-nav-bar" />

    <!-- 已绑定手机状态 -->
    <div v-if="isPhoneBinded" class="binded-container">
      <van-cell-group inset>
        <van-cell title="当前绑定手机" :value="bindedPhone" />
      </van-cell-group>
      <div class="tips">您已成功绑定手机号，如需修改请联系客服</div>
    </div>

    <!-- 未绑定手机状态 -->
    <div v-else class="unbind-container">
      <van-cell-group inset class="form-group">
        <van-field v-model="phoneNumber" label="手机号" placeholder="请输入手机号"
          :rules="[{ required: true, message: '请填写手机号' }]">
          <template #button>
            <van-button size="small" type="primary" :disabled="sendTime < 100" @click="onClickSendCaptcha">{{ sendTip
            }}</van-button>
          </template>
        </van-field>

        <van-field v-model="captcha" label="验证码" placeholder="请输入验证码"
          :rules="[{ required: true, message: '请填写验证码' }]" />
      </van-cell-group>

      <div class="button-container">
        <van-button round block type="primary" :disabled="!phoneNumber || !captcha"
          @click="onBindClick">立即绑定</van-button>
      </div>
    </div>
  </div>
</template>

<script setup>
import env from "@/global/env";
import util from "@/global/util";
import jsUtil from "@/global/jsUtil";
import wechatUtil from "@/global/WechatUtil";
import account from "@/api/account";
import { ref } from "vue";
import { onMounted } from 'vue';
import { showToast } from 'vant';
import { useRoute } from 'vue-router'
import user from "@/global/user";
import { Toast } from "@vant/compat";
import store from "@/store";
import router from '@/router/index.js';

const phoneNumber = ref("");
const captcha = ref("");
const sendTip = ref("发送验证码");
const sendTime = ref(100);
const code = ref("");
const isPhoneBinded = ref(false);
const bindedPhone = ref("");
let route = useRoute();

onMounted(async () => {
  await user.checkAuth();
  // 检查手机绑定状态
  try {
    const bindInfo = await account.getPhoneBindingInfo();
    if (bindInfo && bindInfo.isBinded) {
      isPhoneBinded.value = true;
      bindedPhone.value = bindInfo.phoneNumber;
    }
  } catch (error) {
    showToast('获取用户信息失败');
  }
});

const onClickLeft = () => {
  router.back();
};


const onClickSendCaptcha = async () => {
  if (!phoneNumber.value) {
    showToast('请输入手机号');
    return;
  }
  if (!/^1[3-9]\d{9}$/.test(phoneNumber.value)) {
    showToast('请输入正确的手机号');
    return;
  }
  //设置倒计时秒
  sendTime.value = 60;
  var auth_timetimer = setInterval(() => {
    sendTime.value = sendTime.value - 1;
    sendTip.value = sendTime.value + "s";
    if (sendTime.value <= 0) {
      sendTime.value = 100;
      clearInterval(auth_timetimer);
    }
  }, 1000);

  //发送
  var result = await account.sendRegistCaptcha(phoneNumber.value);
};

const onBindClick = async () => {
  Toast.loading({
    message: '正在绑定...',
    forbidClick: true,
  });
  //发送
  let userId = store.state.user.userId;
  var result = await account.bindGongZongToPhone(userId, phoneNumber.value, captcha.value);
  if (result.isSuccessful) {
    Toast.success("绑定成功");

    const token = result.data.token;
    const userId = result.data.accountId;
    const userName = result.data.nickName;
    store.dispatch('login', [userId, token, userName]);
    router.push('/')
  } else {
    Toast.fail({
      message: "绑定失败," + result.errorMessage,
      duration: "2000"
    });
  }
};
</script>

<style scoped>
.bind-phone-container {
  min-height: 100vh;
  background-color: #f7f8fa;
}

.binded-container,
.unbind-container {
  padding: 20px 16px;
}

.form-group {
  margin-bottom: 24px;
}

.button-container {
  margin: 32px 16px;
}

.tips {
  text-align: center;
  color: #969799;
  font-size: 14px;
  margin-top: 16px;
}


:deep(.van-cell-group--inset) {
  margin: 0;
}

:deep(.van-field__button) {
  padding-left: 8px;
}
</style>
